function initializeNavigation() {
  const menuButton = document.querySelector(".site-header__menu-button");
  const mainNavigation = document.querySelector(".main-navigation");
  if (menuButton && mainNavigation) {
    menuButton.addEventListener("click", () => {
      if (!menuButton.classList.contains("site-header__menu-button--active")) {
        mainNavigation.classList.add("main-navigation--active");
        menuButton.classList.add("site-header__menu-button--active");
      } else if (
        menuButton.classList.contains("site-header__menu-button--active")
      ) {
        mainNavigation.classList.remove("main-navigation--active");
        menuButton.classList.remove("site-header__menu-button--active");
      }
    });
  }
}

export default initializeNavigation;
